import { render, staticRenderFns } from "./WizardInputIcon.vue?vue&type=template&id=24f091ed&"
import script from "./WizardInputIcon.vue?vue&type=script&lang=js&"
export * from "./WizardInputIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports